import React from 'react'

import debounce from 'debounce'

import { connect } from 'react-redux'

import { 
    setClassName,
    setCategory,
    setOrder
} from '../../actions'

import {
    _getAllCategories
} from '../../../../services'

import './index.css'

import {
    Table,
    Input,
    InputNumber,
    Checkbox,
    Cascader
} from 'antd'

class AssetEditor extends React.Component {
    render(){

        const { fileList } = this.props.activeCategoryFeature

        if( !fileList ){
            return null
        }

        console.log(fileList)

        const columns = [{
            title: "Img",
            dataIndex: "url",
            render: (url) => {
                return (
                    <div className="img-container">
                        <img src={url}/>
                    </div>
                )
            }
        },{
            title: "Class Name",
            dataIndex: 'className',
            render: (className, file) => {

                return (
                    <Input
                        style={{width: 160}}
                        onChange={(e) => this.handleClassNameChange({ className: e.target.value, fileId: file.uid })}
                        defaultValue={className}
                    />
                )
            }
        },{
            title: "Category",
            dataIndex: 'category',
            render:( category, file ) => {

                const isMainCategory = this.state.isMainCategory[file.uid] 

                if( file.className === "main" ){
                    return null
                }

                const options = [...this.state.categories.map( _category => {

                    return ({
                        value: _category.titleUrl,
                        label: _category.title,
                        children: isMainCategory? null : _category.children.map( _subCategory => {

                            return ({
                                value: _subCategory.titleUrl,
                                label: _subCategory.title
                            })

                        })
                    }) 

                })]

                const value = category && (category.isSub? [category.parentTitleUrl, category.titleUrl] : [category.titleUrl]) 

                return (
                    <div>
                        <Cascader 
                        value={value}
                        placeholder={category?category.title:"Select Category"}
                        showSearch={{
                            filter: (inputValue, path) => {
                                return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
                            }
                        }}
                        options={options} 
                        onChange={(value) => this.handleCategorySelect({ value, fileId: file.uid })}/>
                        <Checkbox
                            style={{
                                paddingLeft: 8
                            }}
                            checked={isMainCategory}
                            onChange={() => this.handleIsMainCategoryChange( file.uid)}
                        >
                            Main Selectable
                        </Checkbox>
                    </div>
                )  
            }
        },{
            title: "Order",
            dataIndex: 'order',
            render: (order, file) => {

                return <InputNumber
                    value={order}
                    onChange={(order)=>this.handleOrderChange({order, fileId: file.uid})}
                />
            }
        }]

        return (
            <div>
                <Table
                    columns={columns}
                    dataSource={fileList}
                />
            </div>
        )
    }

    constructor(props){
        super(props)

        this.state = {
            categories: [],

            /**
             * Contains the boolean flags for whether 
             * a file allows for the selection of main categories
             */
            isMainCategory: {}
        }
        
    }

    componentDidMount(){
        _getAllCategories()
        .then( res => {

            this.setState({ categories: res.data.categories })

        })
    }

    handleIsMainCategoryChange = (fileId) => {

        const { isMainCategory } = this.state

        isMainCategory[fileId] = !isMainCategory[fileId]

        this.setState({ isMainCategory },() => {
            this.props.setCategory({ fileId, category: null })
        })
    }

    handleClassNameChange = ({ className, fileId }) => {
        
        this.props.setClassName({fileId, className})

    }

    handleOrderChange = ({ order, fileId }) => {

        this.props.setOrder({ fileId, order})
    }
    
    handleCategorySelect = ({ value, fileId}) => {

        const { categories } = this.state

        let category

        const isMainCategory = this.state.isMainCategory[fileId]
        
        if( !isMainCategory ){

            for( let i = 0; i < categories.length; i++ ){

                const _category = categories[i]

                for( let j = 0; j < _category.children.length; j++ ){

                    if( _category.children[j].titleUrl === value[1] ){
                        category = {
                            ..._category.children[j],
                            parentTitleUrl: _category.titleUrl,
                            parentTitle: _category.title,
                            isSub: true
                        }
                        break;
                    }

                }
            }

        } else {

            category = {
                ...categories.filter( _category => _category.titleUrl === value[0] )[0],
                isSub:false
            }

        }

        
        this.props.setCategory({ fileId, category })

    }

}

export default connect(
    state => ({
        activeCategoryFeature: state.categoryFeatures.activeCategoryFeature
    }),
    dispatchEvent => ({
        setClassName: (classNameObj) => dispatchEvent(setClassName(classNameObj)),
        setCategory: (categoryObj) => dispatchEvent(setCategory(categoryObj)),
        setOrder: (orderObj) => dispatchEvent(setOrder(orderObj))
    })
)(AssetEditor)


// WEBPACK FOOTER //
// ./src/components/category-feature/editor/asset-editor/index.js